/*
* <license header>
*/

import React, { useState } from 'react'
import { Flex, View } from '@adobe/react-spectrum'
import Checkmark from '@spectrum-icons/workflow/Checkmark'
import Close from '@spectrum-icons/workflow/Close'

const SAMPLE_CONVERSATIONS = [
  'Unified Shell app deployment steps',
  'GenStudio extension setup',
  'Adobe I/O Runtime actions configuration',
  'API Mesh setup for App Builder',
  'Workfront extension integration',
  'AppBuilder project structure',
  'Environment variables and secrets',
  'Custom actions and event handlers'
]

export const ConversationSidebar = ({ activeConversationId = 'current', onSelectConversation }) => {
  const [conversations, setConversations] = useState([
    { id: 'current', title: 'New conversation' },
    ...SAMPLE_CONVERSATIONS.map((title, i) => ({
      id: `conv-${i}`,
      title
    }))
  ])

  const handleRemove = (e, id) => {
    e.stopPropagation()
    setConversations((prev) => prev.filter((c) => c.id !== id))
  }

  return (
    <View
      UNSAFE_className="AskAssistant-conversationSidebar"
      UNSAFE_style={{
        width: '260px',
        minWidth: '260px',
        padding: '1rem',
        backgroundColor: 'var(--white)',
        borderRight: '1px solid var(--card-border)',
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',
        gap: '0.5rem'
      }}
    >
      {conversations.map((conv) => {
        const isActive = conv.id === activeConversationId
        return (
        <Flex
          key={conv.id}
          alignItems="center"
          gap="size-100"
          UNSAFE_style={{
            padding: '0.5rem 0.75rem',
            borderRadius: '8px',
            backgroundColor: isActive ? '#4285f4' : 'var(--gray-100)',
            color: isActive ? 'white' : 'var(--gray-900)',
            cursor: 'pointer',
            fontSize: '0.875rem'
          }}
          onClick={() => onSelectConversation?.(conv.id)}
        >
          {isActive && <Checkmark size="XS" />}
          <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {conv.title}
          </span>
          <button
            type="button"
            onClick={(e) => handleRemove(e, conv.id)}
            aria-label="Close"
            style={{
              padding: '0.25rem',
              border: 'none',
              background: 'transparent',
              cursor: 'pointer',
              color: 'inherit',
              opacity: 0.8,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <Close size="XS" />
          </button>
        </Flex>
        )
      })}
      <button
        type="button"
        style={{
          padding: '0.5rem 0.75rem',
          borderRadius: '8px',
          backgroundColor: 'var(--gray-100)',
          border: 'none',
          color: 'var(--gray-600)',
          fontSize: '0.875rem',
          cursor: 'pointer',
          marginTop: 'auto'
        }}
      >
        Load 10 more
      </button>
    </View>
  )
}
